export default __webpack_public_path__ + "static/car4-5cf88d3308b2c315f7b5b90259e2b183.glb";